import { render } from "./TermsConditionsPage.vue?vue&type=template&id=389ee5c2"
import script from "./TermsConditionsPage.vue?vue&type=script&lang=js"
export * from "./TermsConditionsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__